import { Box, Typography } from "@mui/material";

import Card from "components/Card";
import { DefaultUrlWeb } from "config/Configuration";
import NumberFormats from "components/NumberFormats";
import React from "react";

export default function BoxReferralHistory({ referralItem }) {
  return (
    <Card marginBottom={1}>
      <Box
        display="flex"
        justifyContent="space-between"
        flexDirection="row-reverse"
      >
        <Typography variant="h5">{referralItem?.type}</Typography>
        <Typography component="p">
          <Typography
            variant="subtitle1"
            component="span"
            color="text.secondary"
          >
            {referralItem?.date}{" "}
          </Typography>
          <Typography
            variant="subtitle1"
            component="span"
            color="text.secondary"
          >
            {referralItem?.time}
          </Typography>
        </Typography>
      </Box>
      <Box display="flex" flexDirection="row-reverse" pt={2}>
        <img
          src={DefaultUrlWeb + referralItem?.coinImageUrl}
          width={"25px"}
          alt=""
        />
        <Typography component="p" px={1}>
          <NumberFormats value={referralItem?.amount} />
        </Typography>
        <Typography variant="subtitle1" component="span" color="text.secondary">
          {referralItem?.coinName}
        </Typography>
      </Box>
    </Card>
  );
}
